import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { User } from "../../_models/user";
import { Router, ActivatedRoute } from "@angular/router";
import { Globals } from "../../_models/globals";
import { AlertService } from '../../_services/alert.service';
import * as moment from 'moment';
import { ApiIntegration } from '../../_services/api.integration';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-big-commerce-user-create',
  templateUrl: './big-commerce-user-create.component.html',
  styleUrls: ['./big-commerce-user-create.component.css']
})
export class BigCommerceUserCreateComponent implements OnInit {
  productImage: string = "/assets/images/default-product.png";
  selectedId: string;
  statusText11: string;
  statusText1: string;
  statusText2: string;
  statusText22: string;
  statusText6: string;
  apiKey: string;
  errorMessage: string;
  uploadImage: string;
  passWord: string;
  hostName: string;
  channelName: string;
  clientSecret: string;
  imageUrl: string;
  clientId: string;
  storeId: string;
  instructions: string = 'N';

  constructor(private alertService: AlertService, private api: ApiIntegration, private user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute, public g: Globals) {
    this.g.page = "Create Store Management";
    this.selectedId = this.route.snapshot.params['id']
  }

  ngOnInit() {
  }

  showInstructions() {
    this.instructions = 'Y';
  }

  typechannelName() {
    this.statusText22 = "";
    if (this.channelName == '' || this.channelName === null || this.channelName === undefined || this.channelName === 'undefined') {
      this.statusText22 = 'Please enter Channel Name';
    }
  }

  typeClientSecret() {
    this.statusText11 = "";
    if (this.clientSecret == '' || this.clientSecret === null || this.clientSecret === undefined || this.clientSecret === 'undefined') {
      this.statusText11 = 'Please enter client secret';
    }
  }


  submit() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/toStoreMagentoCredentials', {
      "accountOwnerId": this.user.accountOwnerId,
      "hostName": this.hostName,
      "connectionName": this.channelName,
      "organizationId": 1,
      "password": this.clientSecret,
      "storeType": "BIGCOMMERCE",
      "clientId": this.clientId,
      "brandImageUrl": this.imageUrl,
      "storeId": this.storeId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Big Commerce', 'Submitted Successfully');
          this.router.navigate(['/admin/storeIntegrations']);
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }


  verify() {
    this.g.loaderDisplay = "display";
    this.statusText1 = "";
    this.statusText2 = "";
    this.statusText6 = "";
    this.statusText22 = "";
    if (this.channelName == '' || this.channelName === null || this.channelName === undefined || this.channelName === 'undefined') {
      this.statusText22 = 'Please enter Channel Name';
    }
    if (this.clientSecret == '' || this.clientSecret === null || this.clientSecret === undefined || this.clientSecret === 'undefined') {
      this.statusText11 = 'Please enter client secret';
    }
    if (this.hostName == '' || this.hostName === null || this.hostName === undefined || this.hostName === 'undefined') {
      this.statusText2 = 'Please enter hostname';
    }
    if (this.statusText22 != "" || this.statusText6 != "" || this.statusText1 != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/verifyBigcommerceConnection/', {
      "hostName": this.hostName,
      "secretKey": this.clientSecret
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Big Commerce', 'Connected Successfully');
          this.submit();
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  loadImage(event) {
    this.productImage = URL.createObjectURL(event.target.files[0]);
    this.uploadImage = event.target.files[0];
    this.errorMessage = "";
    this.submitImage();
  }

  ignoreImage() {
    this.productImage = "/assets/images/default-product.png";
    this.uploadImage = null;
    this.imageUrl = null;
    this.errorMessage = "";
  }

  submitImage() {
    this.g.loaderDisplay = "display";
    const file = this.uploadImage;
    const formData: FormData = new FormData();
    formData.append('file', file);
    var headerObj = new HttpHeaders();
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/uploadImageToS3', formData, { headers: headerObj }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.imageUrl = data['message'];
      } else {
        this.imageUrl = "";
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
        this.errorMessage = "Upload Image Failed Please Re-try";
      });
  }

  typeHostName() {
    this.statusText2 = "";
    if (this.hostName == '' || this.hostName === null || this.hostName === undefined || this.hostName === 'undefined') {
      this.statusText2 = 'Please enter hostname';
    } else if (this.hostName.search("https://") > -1) {
      this.statusText2 = 'Please enter with out https://';
    }
  }
}
